// getIsKaraoke.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';

import getListData from '../selector/getListData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';

const defaultList = [];

/**
 * Select is karaoke by stream id and gift id.
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} streamId - stream id.
 * @param {string} giftId - gift id.
 * @return {boolean} return true if gift is karaoke.
 */
const getIsKaraoke = createCachedSelector(
  (state, streamId) =>
    getListData(state, ['liveStream', streamId, 'karaoke'], 'itemIds'),
  (state, streamId, giftId) =>
    getLiveStreamData(state, [streamId, 'karaoke'], giftId),
  (state, streamId, giftId) => giftId,
  (karaokeMenu = defaultList, karaokeData = undefined, giftId) => {
    return karaokeMenu.includes(giftId) || !!karaokeData;
  }
)((state, streamId, giftId) => `${streamId}:${giftId}`);

export const getIsToyDeviceKaraoke = createCachedSelector(
  (state, streamId, giftId) =>
    getLiveStreamData(state, [streamId, 'karaoke'], giftId),
  karaokeData => {
    return !!karaokeData?.device;
  }
)((state, streamId, giftId) => `${streamId}:${giftId}`);

export default getIsKaraoke;
